<script setup lang="ts">
import AppButton from "@/components/ui-kit/button/AppButton.vue";

const props = defineProps<{
	type: 'chat' | 'group'
	name: string
}>()

const emit = defineEmits<{
	(e: 'cancel'): void,
	(e: 'confirm'): void,
}>()

</script>

<template>
	<div class="dialog-delete-confirm">
		<div class="dialog-delete-confirm__title">
			{{ props.type === 'chat' ? 'Удалить чат?' : 'Удалить группу?' }}
		</div>
		<div class="dialog-delete-confirm__description">
			<template v-if="props.type === 'chat'">
				Вы собираетесь удалить чат с пользователем
				<span class="dialog-delete-confirm__description-name">{{ name }}</span> без возможности восстановления
			</template>
			<template v-else>
				Вы собираетесь удалить группу
				<span class="dialog-delete-confirm__description-name">{{ name }}</span> без возможности восстановления
			</template>
		</div>
		<div class="dialog-delete-confirm__actions">
			<app-button
				class="dialog-delete-confirm__actions-button"
				type="secondary"
				label="Отмена"
				@click="emit('cancel')"
			/>
			<app-button
				class="dialog-delete-confirm__actions-button"
				label="Подтвердить"
				@click="emit('confirm')"
			/>
		</div>
	</div>
</template>

<style scoped lang="scss">
.dialog-delete-confirm {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	height: 100%;
	padding: 12px;
	gap: 8px;

	&__title {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		line-height: 18px;
		font-weight: 600;
		color: #4D4D4D;
	}

	&__description {
		font-size: 14px;
		line-height: 18px;
		color: #4D4D4D;
		text-align: center;

		&-name {
			font-weight: 500;
		}
	}

	&__actions {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 8px;

		&-button {
			flex: 1;
		}
	}
}
</style>
